import WidgetEntity from '../WidgetEntity';
import * as Widgets from '@mm/constants/widgets';

export class OtnWidget extends WidgetEntity {
  static make(pageId: number, sortOrder: number, widgetPageId?: number) {
    return {
      ...super.make(pageId, Widgets.OTN, '', sortOrder),
      config: {
        title: 'Get notified when this product is back to stock!',
        ...(widgetPageId ? { pageId: widgetPageId } : {}),
      },
    };
  }
}
